import React, { useEffect, useState, useSyncExternalStore } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { NAV_LINKS } from '../data/content';

const slug = (s) => s.toLowerCase().replace(/\s+/g, '-');

const subscribeScroll = (callback) => {
  window.addEventListener('scroll', callback, { passive: true });
  return () => window.removeEventListener('scroll', callback);
};
const getScrolled = () => (typeof window !== 'undefined' ? window.scrollY > 24 : false);
const getServerScrolled = () => false;

const Navigation = () => {
  const scrolled = useSyncExternalStore(subscribeScroll, getScrolled, getServerScrolled);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'backdrop-blur-md bg-[var(--bg)]/85 border-b border-[#B8884A]/20 shadow-[0_8px_28px_-22px_rgba(58,36,24,0.35)]' : 'bg-transparent'
      }`}
    >
      <div className="content-container flex items-center py-4 md:py-5 gap-5">
        <Link to="/" data-testid="nav-logo" className="group flex items-center gap-3 shrink-0">
          <img
            src="/brand/marketing-mind-logo-trim.png"
            alt="Marketing Mind — India's leading marketing publication, presenter of the AdAura Awards"
            width="180"
            height="48"
            decoding="async"
            className="h-6 md:h-8 w-auto object-contain"
          />
          <span className="hidden md:flex xl:hidden 2xl:flex flex-col leading-none border-l border-[#B8884A]/40 pl-3">
            <span className="font-serif tracking-[0.02em] text-[13px] text-[#3A2418]">The AdAura Awards</span>
            <span className="font-serif tracking-[0.28em] text-[9px] uppercase text-[#3A2418]/60 mt-1">Edition · 2026</span>
          </span>
        </Link>

        <nav className="hidden xl:flex items-center gap-4 2xl:gap-5 whitespace-nowrap">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === '/'}
              data-testid={`nav-link-${slug(l.label)}`}
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <button
          aria-label="Open menu"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((s) => !s)}
          className="xl:hidden ml-auto bg-[var(--brand-brass)] hover:bg-[#8B6532] text-white border border-[var(--brand-brass)] px-3.5 py-2.5 text-[10px] tracking-[0.25em] uppercase font-semibold leading-none transition-colors"
        >
          {open ? 'Close' : 'Menu'}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-panel" className="xl:hidden bg-[#3A2418] border-t border-[#C9A56C]/25">
          <div className="content-container py-8 flex flex-col gap-5">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === '/'}
                data-testid={`nav-mobile-link-${slug(l.label)}`}
                className={({ isActive }) => `text-[13.5px] tracking-[0.14em] uppercase font-medium text-white/95 hover:text-[#D9B26A] ${isActive ? '!text-[#D9B26A]' : ''}`}
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navigation;
